import { gql } from "@apollo/client";

export const GET_TEST_SITES = gql`
  query GET_TEST_SITES {
    odooTestSites {
      url
      success
      date
    }
  }
`;

export const GET_ALL_FIELDS = gql`
  query GET_ALL_FIELDS($model: String!) {
    allFields(model: $model) {
      name
      type
      string
      required
      readonly
      store
      searchable
      sortable
      manual
      depends
      help
    }
  }
`;

export const QUERY_ODOO = gql`
  query QUERY_ODOO(
    $model: String!
    $action: String!
    $conditions: String!
    $fields: [String]!
  ) {
    queryOdoo(
      model: $model
      action: $action
      conditions: $conditions
      fields: $fields
    )
  }
`;
